import { defaults, getAPIMethod } from 'typed/api';
import { ExtractAction, action, entityActionSet, networkAction } from './utils';

export const
    agendaThemes = entityActionSet(defaults.AgendaTheme, {
        loadAll: networkAction('LOAD_ALL_AGENDA_THEMES', getAPIMethod('AgendaTheme', 'loadAll')),
        add: networkAction('ADD_AGENDA_THEME', getAPIMethod('AgendaTheme', 'add')),
        edit: networkAction('EDIT_AGENDA_THEME', getAPIMethod('AgendaTheme', 'edit')),
        delete: networkAction('DELETE_AGENDA_THEME', getAPIMethod('AgendaTheme', 'delete'))
    }),

    agendaTimeSerieRules = entityActionSet(defaults.AgendaTimeSerieRuleReport, {
        loadAll: networkAction('LOAD_ALL_AGENDA_TIME_SERIE_RULES', getAPIMethod('AgendaTimeSerieRule', 'loadAll')),
        load: networkAction('LOAD_AGENDA_TIME_SERIE_RULE', getAPIMethod('AgendaTimeSerieRule', 'load')),
        add: networkAction('ADD_AGENDA_TIME_SERIE_RULE', getAPIMethod('AgendaTimeSerieRule', 'add')),
        edit: networkAction('EDIT_AGENDA_TIME_SERIE_RULE', getAPIMethod('AgendaTimeSerieRule', 'edit')),
        delete: networkAction('DELETE_AGENDA_TIME_SERIE_RULE', getAPIMethod('AgendaTimeSerieRule', 'delete'))
    }),

    agendaTimeSerieEvents = {
        ...entityActionSet(defaults.AgendaTimeSerieRuleReport, defaults.AgendaTimeSerieEvent, {
            edit: networkAction('EDIT_AGENDA_TIME_SERIE_EVENT', getAPIMethod('AgendaTimeSerieEvent', 'edit')),
            delete: networkAction('DELETE_AGENDA_TIME_SERIE_EVENT', getAPIMethod('AgendaTimeSerieEvent', 'delete'))
        }),
        convertToEntity: (parentID: number, entityID: number) =>
            networkAction('CONTERT_AGENDA_TIME_SERIE_EVENT_TO_ENTITY', { parentID, entityID }, getAPIMethod<number>('AgendaTimeSerieEvent', 'convertEventToItem'), entityID)
    },

    agendaTimeReservations = {
        ...entityActionSet(defaults.AgendaTimeReservation, {
            loadAll: networkAction('LOAD_ALL_AGENDA_TIME_RESERVATIONS', getAPIMethod('AgendaTimeReservation', 'loadAll')),
            load: networkAction('LOAD_AGENDA_TIME_RESERVATION', getAPIMethod('AgendaTimeReservation', 'load')),
            add: networkAction('ADD_AGENDA_TIME_RESERVATION', getAPIMethod('AgendaTimeReservation', 'add')),
            edit: networkAction('EDIT_AGENDA_TIME_RESERVATION', getAPIMethod('AgendaTimeReservation', 'edit')),
            delete: networkAction('DELETE_AGENDA_TIME_RESERVATION', getAPIMethod('AgendaTimeReservation', 'delete')),
            voidAll: action('VOID_ALL_AGENDA_TIME_RESERVATIONS')
        }),
        recreate: (entityID: number) =>
            networkAction('RECREATE_AGENDA_TIME_RESERVATION', { entityID }, getAPIMethod('AgendaTimeReservation', 'recreateFromEventSource'), entityID),
        requestConversion: (entityID: number) =>
            networkAction('REQUEST_AGENDA_TIME_RESERVATION_CONVERSION', { entityID }, getAPIMethod('AgendaTimeReservation', 'requestConversion'), entityID)
    },

    agendaFlags = entityActionSet(defaults.AgendaFlag, {
        loadAll: networkAction('LOAD_ALL_AGENDA_FLAGS', getAPIMethod('AgendaFlag', 'loadAll')),
        add: networkAction('ADD_AGENDA_FLAG', getAPIMethod('AgendaFlag', 'add')),
        edit: networkAction('EDIT_AGENDA_FLAG', getAPIMethod('AgendaFlag', 'edit')),
        delete: networkAction('DELETE_AGENDA_FLAG', getAPIMethod('AgendaFlag', 'delete'))
    });

export type AgendaAction = ExtractAction<
| typeof agendaThemes
| typeof agendaTimeSerieRules
| typeof agendaTimeSerieEvents
| typeof agendaTimeReservations
| typeof agendaFlags
>;
